import { render } from "./sales-list.vue?vue&type=template&id=caf186de&scoped=true"
import script from "./sales-list.vue?vue&type=script&lang=js"
export * from "./sales-list.vue?vue&type=script&lang=js"

import "./sales-list.vue?vue&type=style&index=0&id=caf186de&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caf186de"]])

export default __exports__